import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
/* Styles and Images */
import CompanyLogoWhite from "../../assets/img/m-comp-logo-white.png";

export default function EmailVerified() {
    /* Use States / Setters */
    const navigate = useNavigate();
    const { user, userMetaData } = useAuth();
    
    // Redirect if already logged in
    useEffect(() => {
        if (user && userMetaData) {
            const redirectURL = userMetaData.user_role === 'administrator' ? '/admin/dashboard' : '/dashboard';
            navigate(redirectURL);
        }
    }, [user, userMetaData, navigate]);

    /* Custom Functions */
    async function onSubmit(e){
        e.preventDefault();
    }
    
    return (
        <section className="main-form-section">
            <div className="container">
                <div className="banner-wrapper">
                    <div className="form-section-wrapper">
                        <form onSubmit={onSubmit}>
                            <div className="form-header register-header"><img src={CompanyLogoWhite} alt="Company Logo" /></div>
                            <div className="login-heading">
                                <h2>EMAIL VERIFIED SUCCESSFULLY</h2>
                                <p>Your email has been successfully verified.</p>
                            </div>
                            <div className="form-group">
                                <a href="/sign-in" className="submit-button text-center">
                                    Proceed to Login
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
